export default __webpack_public_path__ + "static/cafe_36075-b853e6b5658c398c32fcb35d4bb8c1e5.png";